function restoreRoboracter3DCart() {
  try {
    var rows = document.querySelectorAll('.cart-item, tr[id^="CartDrawer-Item-"], tr[id^="CartItem-"]');
    rows.forEach(function (row) {
      var text = (row.textContent || '');
      var is3D = row.classList.contains('cart-item--3d-print') ||
                 text.indexOf('P3D Model') !== -1 ||
                 text.indexOf('Printer:') !== -1 ||
                 text.indexOf('3D Printing') !== -1 ||
                 text.indexOf('.stl') !== -1 ||
                 text.indexOf('Infill:') !== -1;

      if (!is3D) return;

      // 1. Extract hash or key
      var hashAttr = row.getAttribute('data-3d-model');
      var hashMatch = text.match(/P3D Model:\s*([^\s\n\r]+)/);
      var hash = hashAttr || (hashMatch ? hashMatch[1].trim() : '');
      
      var cached = (hash && localStorage.getItem('p3d_thumb_' + hash)) || 
                   localStorage.getItem('p3d_thumb_latest') || 
                   (hash && sessionStorage.getItem('p3d_thumb_' + hash)) ||
                   sessionStorage.getItem('p3d_thumb_latest') ||
                   window.p3d_thumb_latest;

      // 2. Image Injection & Stylish Border Styling
      var mediaTd = row.querySelector('.cart-item__media');
      if (mediaTd) {
        var img = mediaTd.querySelector('img');
        if (cached) {
          if (!img) {
            img = document.createElement('img');
            img.className = 'cart-item__image cart-item-3d-thumb';
            mediaTd.innerHTML = '';
            mediaTd.appendChild(img);
          }
          if (img.src !== cached) {
            img.src = cached;
          }
        }
        if (img) {
          img.style.objectFit = 'contain';
          img.style.width = '75px';
          img.style.height = '75px';
          img.style.maxWidth = '100%';
          img.style.display = 'block';
          img.style.border = '1px solid #e2e8f0';
          img.style.borderRadius = '8px';
          img.style.background = '#f8fafc';
          img.style.padding = '4px';
          img.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)';

          var parentDiv = img.parentElement;
          if (parentDiv && parentDiv !== mediaTd && parentDiv.tagName === 'DIV') {
            parentDiv.style.border = '1px solid #e2e8f0';
            parentDiv.style.borderRadius = '8px';
            parentDiv.style.background = '#f8fafc';
            parentDiv.style.padding = '4px';
            parentDiv.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)';
            parentDiv.style.display = 'flex';
            parentDiv.style.alignItems = 'center';
            parentDiv.style.justifyContent = 'center';
            img.style.border = 'none';
            img.style.background = 'transparent';
            img.style.padding = '0';
            img.style.boxShadow = 'none';
          }
        }
      }

      // 3. Hide Vendor
      var vendorEl = row.querySelector('.cart-item__details > p.caption-with-letter-spacing, .caption-with-letter-spacing.light');
      if (vendorEl && vendorEl.textContent.trim().toLowerCase() === 'roboracter') {
        vendorEl.style.display = 'none';
      }

      // 4. Hide Rs. 1.00 Unit Price below product title
      var unitPriceOptions = row.querySelectorAll('.cart-item__details .product-option');
      unitPriceOptions.forEach(function(po) {
        var t = po.textContent.trim();
        if ((t.includes('1.00') || t.includes('₹1') || t.includes('Rs. 1')) && !t.includes(':')) {
          po.style.display = 'none';
        }
      });
      var discountedPrices = row.querySelector('.cart-item__details .cart-item__discounted-prices');
      if (discountedPrices) {
        discountedPrices.style.display = 'none';
      }

      // 5. Completely lock and remove plus/minus buttons on 3D print items
      var quantityInputEl = row.querySelector('quantity-input');
      var qtyWrapper = row.querySelector('.cart-item__quantity-wrapper, .cart-item__quantity');
      if (quantityInputEl) {
        var input = quantityInputEl.querySelector('.quantity__input');
        var hiddenVal = input ? (parseInt(input.value) || 1) : 1;
        if (hiddenVal <= 1) {
          // Check if custom unit price is present in text e.g. "Rs. 100.00"
          var matchPrice = text.match(/₹\s*([0-9]+)|Rs\.\s*([0-9]+)/);
          if (matchPrice) {
            hiddenVal = parseInt(matchPrice[1] || matchPrice[2]) || hiddenVal;
          }
        }
        
        var hiddenInput = row.querySelector('input[type="hidden"][name="updates[]"]');
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'updates[]';
          hiddenInput.value = hiddenVal;
          if (qtyWrapper) qtyWrapper.appendChild(hiddenInput);
        } else if (hiddenVal > 1) {
          hiddenInput.value = hiddenVal;
        }

        var staticDiv = document.createElement('div');
        staticDiv.className = 'quantity cart-quantity 3d-locked-qty';
        staticDiv.style.cssText = 'min-height: 4.4rem; display: flex; align-items: center; justify-content: center; width: 45px; margin: 0 auto; user-select: none;';
        staticDiv.innerHTML = '<span style="font-weight: 700; font-size: 1.3rem; color: #0f172a;">1</span>';
        
        quantityInputEl.replaceWith(staticDiv);
      } else {
        var qtyInput = row.querySelector('.quantity__input');
        if (qtyInput) {
          qtyInput.value = '1';
          qtyInput.setAttribute('value', '1');
          qtyInput.setAttribute('readonly', 'readonly');
          qtyInput.style.pointerEvents = 'none';
        }
      }
    });
  } catch (err) {
    console.warn('Roboracter 3D cart restorer:', err);
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setfooterCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
      restoreRoboracter3DCart();
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
        restoreRoboracter3DCart();
      }
    });
  }
  
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      restoreRoboracter3DCart();
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      restoreRoboracter3DCart();
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    restoreRoboracter3DCart();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
      restoreRoboracter3DCart();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  setfooterCartIconAccessibility() {
    const cartLink = document.querySelector('#footer-cart-icon');
    if(cartLink){
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
        restoreRoboracter3DCart();
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
          restoreRoboracter3DCart();
        }
      });
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  onCartUpdate() {
    const sections = this.getSectionsToRender().map((s) => s.section);
    fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: sections })
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.getSectionsToRender().forEach((section => {
          const sectionEl = document.getElementById(section.id);
          const elementToReplace = sectionEl ? (sectionEl.querySelector(section.selector) || sectionEl) : null;
          if (elementToReplace && parsedState.sections && parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        restoreRoboracter3DCart();
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'footer-cart-icon',
        section: 'footer-cart-icon',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Auto-run restoration immediately on load, DOM ready, and observer mutations
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', restoreRoboracter3DCart);
} else {
  restoreRoboracter3DCart();
}

window.addEventListener('load', restoreRoboracter3DCart);
document.addEventListener('cart:updated', restoreRoboracter3DCart);

// Observe DOM mutations to auto-repair any AJAX drawer updates
document.addEventListener('DOMContentLoaded', function () {
  restoreRoboracter3DCart();
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var observer = new MutationObserver(function () {
      restoreRoboracter3DCart();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // Click interceptor for any cart trigger buttons
  document.addEventListener('click', function(e) {
    if (e.target.closest('#cart-icon-bubble, #footer-cart-icon, a[href$="/cart"], .header__icon--cart, .cart-count-bubble')) {
      setTimeout(restoreRoboracter3DCart, 30);
      setTimeout(restoreRoboracter3DCart, 150);
      setTimeout(restoreRoboracter3DCart, 400);
    }
  });
});
